<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :exportDataOptions="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getNameFilter } from '@/utils/common/tableFilter'
import expectStatus from '@/constants/expectStatus'
// import { disableDeleteAction } from '@/utils/common/tableActions'
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'AiGatewayList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'ai_gateways',
        getParams: this.getParam,
        filterOptions: {
          name: getNameFilter(),
        },
        steadyStatus: {
          status: Object.values(expectStatus.aiGateway).flat(),
        },
        hiddenColumns: ['created_at'],
      }),
      groupActions: [
        {
          label: this.$t('common.create'),
          permission: 'ai_gateway_create',
          action: () => {
            this.createDialog('AiGatewayCreateDialog', {
              vm: this,
              columns: this.columns,
              onManager: this.onManager,
              type: 'create',
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
              validate: true,
            }
          },
        },
        // {
        //   label: this.$t('compute.text_275'),
        //   actions: () => {
        //     return [
        //       {
        //         label: this.$t('compute.perform_sync_status'),
        //         permission: 'modelarts_perform_syncstatus',
        //         action: () => {
        //           this.onManager('batchPerformAction', {
        //             steadyStatus: ['running', 'ready'],
        //             managerArgs: {
        //               action: 'syncstatus',
        //             },
        //           })
        //         },
        //         meta: () => ({
        //           validate: this.list.selected.length,
        //         }),
        //       },
        //       {
        //         label: this.$t('compute.perform_change_owner', [this.$t('dictionary.project')]),
        //         permission: 'modelarts_perform_change_owner',
        //         action: () => {
        //           this.createDialog('ChangeOwenrDialog', {
        //             data: this.list.selectedItems,
        //             columns: this.columns,
        //             onManager: this.onManager,
        //             name: 'ModelArts',
        //             resource: 'modelarts_pools',
        //           })
        //         },
        //         meta: () => {
        //           const ret = {
        //             validate: false,
        //             tooltip: null,
        //           }
        //           ret.validate = true
        //           return ret
        //         },
        //       },
        //       disableDeleteAction(this, {
        //         name: 'ModelArts',
        //         meta: () => {
        //           const ret = { validate: true }
        //           return ret
        //         },
        //       }),
        //       {
        //         label: this.$t('table.action.delete'),
        //         permission: 'modelarts_delete',
        //         action: () => {
        //           this.createDialog('DeleteResDialog', {
        //             vm: this,
        //             data: this.list.selectedItems,
        //             columns: this.columns,
        //             title: this.$t('table.action.delete'),
        //             name: 'ModelArts',
        //             onManager: this.onManager,
        //           })
        //         },
        //         meta: () => {
        //           const ret = { validate: this.list.selected.length }
        //           if (this.list.selectedItems.some(item => !item.can_delete)) {
        //             ret.validate = false
        //             return ret
        //           }
        //           return ret
        //         },
        //       },
        //     ]
        //   },
        // },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        title: this.$t('ai.ai_gateway'),
        items: this.columns,
      }
    },
  },
  created () {
    this.initSidePageTab('detail')
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...this.getParams,
        details: true,
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'AiGatewaySidePage', {
        id: row.id,
        resource: 'ai_gateways',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
<style>

</style>
